<template>
    <div class="row">
    	<div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="tab == 0? 'active': ''" v-on:click.prevent="tab = 0"><a href="#">{{$t('acc_Aclist')}}</a></li>
                <li :class="tab == 1? 'active': ''" v-on:click.prevent="tab = 1"><a href="#">{{$t('acc_changeLeverage')}}</a></li>
                <li :class="tab == 2? 'active': ''" v-on:click.prevent="tab = 2"><a href="#">{{$t('acc_changeplatPass')}}</a></li>
                <li :class="tab == 3? 'active': ''" v-on:click.prevent="tab = 3"><a href="#">{{$t('acc_InternalTrans')}}</a></li>
            </ul>
        </div>
        <div class="col-12" v-if="tab == 0">
        	<app-account-list></app-account-list>
        </div>
        <div class="col-12"  v-if="tab == 1">
	       <app-change-leverage></app-change-leverage>
	    </div>
	    <div class="col-12" v-if="tab == 2">
	    	<app-change-password></app-change-password>
	    </div>
        <div class="col-12" v-if="tab == 3">
            <app-internal-transfer></app-internal-transfer>
        </div>
    </div>
</template>
<script>
    import internalTransfer from '../manageAccounts/internal_transfer'
    import AccountList from '../manageAccounts/account_list'
    import changeLeverage from '../manageAccounts/change_leverage'
    import changePassword from '../manageAccounts/change_password1'
    export default {
        name: 'Wallet',
        data() {
            return {
                //============message and loader ===========
                col_span : 9,
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                tab : 0
            }
        },
		components:{
			appInternalTransfer : internalTransfer,
			appAccountList : AccountList,
            appChangeLeverage : changeLeverage,
            appChangePassword : changePassword
		},
        created(){
            if(this.$route.query.page && this.$route.query.page == 'request-bonus'){
                this.tab = '1'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/account/account.vue